import React, {useContext} from "react";

import { buyNowContext } from "../BuyNow";
import { calcShippingPrice } from "../../utils/pricingHelper";

/**
 * Return a string representing the shipping price of the order.
 */
const ShippingPrice = () => {
  const { lineItems, shippingStageState } = useContext(buyNowContext);
  const { country, shippingMethod } = shippingStageState;

  return calcShippingPrice(lineItems, country, shippingMethod).toFixed(2);
};

export default ShippingPrice;